<template>
  <v-row>
    <v-col>
      <Allergy :attendance="attendance" :showForm="false" :allowDelete="false" />

      <SurgeryDetail :surgery="surgery" />

      <SurgeryVitalMeasurementList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <SurgeryTherapyList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <v-row>
        <v-col>
          <v-textarea
            label="Notas"
            v-model="observation"
            placeholder=" "
            hide-details
            outlined
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="text-h5 gray--text">
          Alta cirúrgica
        </v-col>
      </v-row>

      <v-row align="end">
        <v-col cols="2">
          <v-row dense>
            <v-col>
              Removido acesso venoso
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <v-radio-group
                v-model="removedVenousAccess"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                @change="debouncedSave"
                :disabled="disabled"
              >
                <v-radio label="Sim" :value="true" />
                <v-radio label="Não" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-row dense>
            <v-col>
              Removido eletrodos
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <v-radio-group
                v-model="removedElectrodes"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                @change="debouncedSave"
                :disabled="disabled"
              >
                <v-radio label="Sim" :value="true" />
                <v-radio label="Não" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="5">
          <v-checkbox
            v-model="patientReceivedPrescription"
            label="Entregue receituário de pós-operatório ao paciente"
            class="mt-0"
            hide-details
            dense
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>

        <v-col cols="3">
          <v-checkbox
            v-model="medicalRelease"
            label="conceder alta para o paciente"
            class="mt-0"
            hide-details
            dense
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="text-h5 gray--text">
          Anexos
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <FileUpload
            ownerType="Surgery::Postoperative"
            :ownerId="surgery.postoperative.id"
            :disabled="disabled"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import Allergy from "@/components/medical_record/hpp/allergy.vue";
  import SurgeryDetail from "@/components/surgery/detail.vue";
  import SurgeryVitalMeasurementList from "@/components/surgery/vital_measurement/list/index.vue";
  import SurgeryTherapyList from "@/components/surgery/therapy/list/index.vue";

  export default {
    name: "SurgeryDetails",
    props: {
      surgery: Object,
      refreshSurgery: Function,
      setSurgeryMoment: Function,
      surgeryMoment: String,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Allergy,
      SurgeryDetail,
      SurgeryVitalMeasurementList,
      SurgeryTherapyList,
    },
    data() {
      return {
        medicalRelease: false,
        removedVenousAccess: false,
        removedElectrodes: false,
        patientReceivedPrescription: false,
        observation: "",
      };
    },
    created() {
      this.debouncedSave = this.lodash.debounce(this.saveSurgeryPostoperative, 2000);
    },
    mounted() {
      this.medicalRelease = this.surgery.postoperative.medicalRelease;
      this.removedVenousAccess = this.surgery.postoperative.removedVenousAccess;
      this.removedElectrodes = this.surgery.postoperative.removedElectrodes;
      this.patientReceivedPrescription = this.surgery.postoperative.patientReceivedPrescription;
      this.observation = this.surgery.postoperative.observation;
      this.setSurgeryMoment("postoperative");
    },
    computed: {
      attendance() {
        return this.surgery.attendance;
      },
    },
    methods: {
      saveSurgeryPostoperative() {
        if (this.disabled) return;

        return this.apolloMutate({
          mutation: require("@/graphql/surgery/save_surgery_postoperative.gql"),
          variables: {
            surgeryId: this.surgery.id,
            medicalRelease: this.medicalRelease,
            removedVenousAccess: this.removedVenousAccess,
            removedElectrodes: this.removedElectrodes,
            patientReceivedPrescription: this.patientReceivedPrescription,
            observation: this.observation,
          },
        }).then(() => {
          this.refreshSurgery();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
